import { render, staticRenderFns } from "./jingyin.vue?vue&type=template&id=18f6f292&scoped=true"
import script from "./jingyin.vue?vue&type=script&lang=js"
export * from "./jingyin.vue?vue&type=script&lang=js"
import style0 from "./jingyin.vue?vue&type=style&index=0&id=18f6f292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6f292",
  null
  
)

export default component.exports